// load javascripts
import './js/index';
// load stylesheets
import './scss/index.scss';
